<template>
  <div id="show">
    <h2>ファイル詳細</h2>
    <p>他人にこのファイルを共有したい場合、現在のページのURLを共有してください</p>
    <hr>
    <div v-show="loading" class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    <div v-show="result">
      <div v-show="success">
        <p>削除しました</p>
      </div>
      <div v-show="!success">
        <p class="has-text-danger">{{ errMsg }}</p>
      </div>
    </div>
    <div v-show="!loading && main">
      <img style="width:400px"
           v-bind:src="'https://files-uploader.xzy.pw/upload/' + this.$route.params.file_name + '?show=true'"
           alt="アップロード"/>
      <p>{{ this.$route.params.file_name }}</p>
      <br>
      <div class="buttons is-centered">
        <section class="copy">
          <p v-if="isCopied" class="has-text-info">URLをコピーしました</p>
          <div @click="exec" class="button is-primary">URLをコピー</div>
        </section>
        <div @click="deleteFile" class="button is-danger">削除する</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Show',
  data () {
    return {
      main: true,
      loading: false,
      result: false,
      success: false,
      errMsg: '',
      isCopied: false
    }
  },
  methods: {
    exec: function () {
      if (this.execCopy('https://files-uploader.xzy.pw/upload/' + this.$route.params.file_name) === false) {
        alert('このブラウザでは対応していません')
      } else {
        this.isCopied = true
      }
    },
    execCopy: function (string) {
      let temp = document.createElement('div')
      temp.appendChild(document.createElement('pre')).textContent = string
      let s = temp.style
      s.position = 'fixed'
      s.left = '-100%'
      document.body.appendChild(temp)
      document.getSelection().selectAllChildren(temp)
      let result = document.execCommand('copy')
      document.body.removeChild(temp)
      return result
    },
    deleteFile: function () {
      this.main = false
      this.loading = true

      this.$axios.get(this.baseURL + '/delete?file_name=' + this.$route.params.file_name, { withCredentials: true })
        .then(response => {
          this.loading = false
          this.result = true
          this.success = true
        }).catch((response) => {
          if (response.response.data === 'not_allowed') {
            this.errMsg = 'このファイルを削除する権限はあなたにありません 😃'
          }
          if (response.response.data === 'get_users_files') {
            this.errMsg = 'このファイルの所有者を調べるのに失敗しました...🙏 解決までお待ち下さい 😃'
          }
          if (response.response.data === 'delete_from_db') {
            this.errMsg = 'ファイルを削除するのに失敗しました...😫 解決までお待ち下さい 🙏'
          }
          if (response.response.data === 'delete') {
            this.errMsg = 'ファイルを削除するのに失敗しました...😫 解決までお待ち下さい 🙏'
          }
          this.loading = false
          this.result = true
        })
    }
  }
}
</script>

<style scoped>
  .copy {
    margin: 0 2rem 0 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Show.vue